import { render } from "./SettingsTabs.vue?vue&type=template&id=02ef9c5e"
import script from "./SettingsTabs.vue?vue&type=script&lang=ts"
export * from "./SettingsTabs.vue?vue&type=script&lang=ts"
script.render = render

export default script